// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Xn_dvbE9w149sWOKgooR.t5zNf18r4XgI7GKo1oLI{margin-top:37px}.Xn_dvbE9w149sWOKgooR.e5gS9pb84QQJGGF3neIe{margin-top:40px}.HeuHZlTKd6k2c3uGsEzr{justify-content:space-between;align-items:center;margin-bottom:4px;display:flex}.yRLFN8Tab9cZjxh_F4f1{padding-right:10px}.yRLFN8Tab9cZjxh_F4f1.t5zNf18r4XgI7GKo1oLI{color:var(--green-60)}.yRLFN8Tab9cZjxh_F4f1.e5gS9pb84QQJGGF3neIe{color:var(--red-60)}.JH1h4hMSgEwLlXYpRXux{align-items:center;display:flex}.zwuoE04cIl8vwBcKRbBy{margin-bottom:16px}.CSmRvtMd2QAj6kso43WO{padding-left:24px;position:relative}.CSmRvtMd2QAj6kso43WO:after{background-color:var(--gray-30);content:"";width:2px;position:absolute;top:0;bottom:0;left:7px}.CSmRvtMd2QAj6kso43WO.t5zNf18r4XgI7GKo1oLI:after{background-color:var(--green-40)}.CSmRvtMd2QAj6kso43WO.e5gS9pb84QQJGGF3neIe:after{background-color:var(--red-40)}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `Xn_dvbE9w149sWOKgooR`,
	"qualified": `t5zNf18r4XgI7GKo1oLI`,
	"disqualified": `e5gS9pb84QQJGGF3neIe`,
	"label": `HeuHZlTKd6k2c3uGsEzr`,
	"label__icon": `yRLFN8Tab9cZjxh_F4f1`,
	"labelIcon": `yRLFN8Tab9cZjxh_F4f1`,
	"label__box": `JH1h4hMSgEwLlXYpRXux`,
	"labelBox": `JH1h4hMSgEwLlXYpRXux`,
	"label__description": `zwuoE04cIl8vwBcKRbBy`,
	"labelDescription": `zwuoE04cIl8vwBcKRbBy`,
	"section": `CSmRvtMd2QAj6kso43WO`
};
export default ___CSS_LOADER_EXPORT___;
